"use client";

import { MapPin, Tag } from "lucide-react";
import { Link } from "react-router-dom";

const HappeningCard = ({
  image,
  imageAlt = "Event Image",
  category,
  title,
  description,
  dateTime,
  location,
  time,
  date,
  link,
  onGetDirection = () => {}
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden mb-4 w-full max-w-[280px] sm:max-w-full">
      {/* Mobile layout (stacked) for small screens */}
      <div className="block sm:hidden h-[420px] flex flex-col">
        <div className="relative h-48 w-full flex-shrink-0">
          <img
            src={image || "/placeholder.svg"}
            alt={imageAlt}
            className="w-full h-full object-cover"
          />
          {category && (
            <div className="absolute top-3 left-3 bg-white/90 text-gray-800 text-xs font-medium px-2.5 py-1.5 rounded-md shadow-sm flex items-center gap-1.5">
              {category.icon || <Tag className="h-3 w-3" />} {category.name}
            </div>
          )}
        </div>
        <div className="p-4 flex flex-col flex-grow">
          <Link
            to={link}
            className="font-bold  text-xl text-gray-900 line-clamp-1 h-[28px] overflow-hidden"
          >
            {title}
          </Link>
          <p className="text-sm text-gray-600 mt-1 mb-auto line-clamp-2 h-[40px] overflow-hidden">
            {description}
          </p>

          <div className="flex items-start mt-3">
            <div className="flex-1 flex items-center text-sm text-gray-600">
              <MapPin className="h-4 w-4 mr-1.5 text-gray-500 flex-shrink-0" />
              <span className="line-clamp-2">{location}</span>
            </div>
            <div className="mx-2 h-12 border-r border-gray-200" />

            <div className="flex-1">
              <div className="text-base font-semibold text-gray-800">
                {time}
              </div>
              <div className="text-sm text-gray-500">
                {typeof date === "object"
                  ? `${date.day} ${date.month} ${date.year}`
                  : date}
              </div>
            </div>
          </div>

          <button
            className="mt-4 w-full py-2.5 bg-transparent border border-gray-300 text-gray-800 rounded-lg text-sm font-medium transition-colors hover:bg-[#7B189F] hover:border-[#7B189F] hover:text-white active:bg-[#6a1587] flex items-center justify-center gap-1"
            onClick={onGetDirection}
          >
            Get Direction
          </button>
        </div>
      </div>

      {/* Desktop/tablet layout (horizontal) for medium screens and up */}
      <div className="hidden sm:flex h-[250px]">
        <div className="relative w-1/3 min-w-[200px] max-w-[280px] flex-shrink-0">
          <img
            src={image || "/placeholder.svg"}
            alt={imageAlt}
            className="w-full h-full object-cover"
          />
          {category && (
            <div className="absolute top-4 left-4 bg-white/90 text-gray-800 text-xs font-medium px-3 py-1.5 rounded-md shadow-sm flex items-center gap-1.5">
              {category.icon || <Tag className="h-3 w-3" />} {category.name}
            </div>
          )}
        </div>
        <div className="flex-1 p-4 md:p-6 flex flex-col justify-between">
          <div className="flex flex-col">
            <Link
              to={link}
              className="text-lg md:text-xl font-semibold text-gray-800 line-clamp-1 h-[28px] overflow-hidden"
            >
              {title}
            </Link>
            <p className="text-xs md:text-sm text-gray-600 mt-2 line-clamp-2 h-[40px] overflow-hidden">
              {description}
            </p>
            <div className="my-2 border-t border-gray-200" />
          </div>
          <div>
            <div className="flex flex-row items-center justify-between">
              <div className="flex items-center gap-8">
                <div>
                  <div className="text-sm md:text-base font-medium text-gray-800">
                    {time}
                  </div>
                  <div className="text-xs md:text-sm text-gray-500">
                    {typeof date === "object"
                      ? `${date.day} ${date.month} ${date.year}`
                      : date}
                  </div>
                </div>
                <div className="h-10 border-r border-gray-200" />
                <div className="flex items-center text-xs md:text-sm text-gray-600">
                  <MapPin className="h-4 w-4 mr-2 text-gray-500" />
                  <span className="line-clamp-1 max-w-[200px]">{location}</span>
                </div>
              </div>
              <button
                className="w-auto px-4 md:px-6 py-2 md:py-2.5 bg-transparent border border-gray-300 text-gray-800 rounded-lg text-sm font-medium transition-colors hover:bg-[#7B189F] hover:border-[#7B189F] hover:text-white active:bg-[#6a1587] flex items-center justify-center gap-2"
                onClick={onGetDirection}
              >
                Get Direction
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HappeningCard;
